// extracted by mini-css-extract-plugin
module.exports = {"number":"NumberFormater_number_2RT_s","fraction":"NumberFormater_fraction_2zOni"};